enum ArchitectureEnum {
  X64 = 'x64',
  IA32 = 'ia32',
}

export default ArchitectureEnum;
